import { Flex, Text } from "@jsq/ds/core";
import { DocumentRowItem } from "~/pages/Compliance/CaseDetailsDrawer/Documents/types";
import { TypedAGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { fullHeightCell } from "../styles_vanilla.css";
import { getDocumentDisplaySubtype } from "./utils";

interface Props {
  params: TypedAGGridCellRenderParams<DocumentRowItem>;
}

export const TypeCellRenderer = ({ params }: Props) => {
  const metadata = params.data.metadata;
  const subtype = metadata?.find((x) => x.key === "type")?.value;
  const display = getDocumentDisplaySubtype(params.data.baseType, subtype);

  return (
    <Flex flexDirection="column" justifyContent="center" className={fullHeightCell}>
      <Text data-testid="doc-type" marginBottom="xs">
        {params.value.toString()}
      </Text>
      {display && <Text variant="secondary-sm">{display}</Text>}
    </Flex>
  );
};
